/** @format */
import React from 'react';
import { UseFormRegister, FieldValues, FieldErrors } from 'react-hook-form';
import Translate from '@components/translation/translate-text-wrapper';
import { FieldProperties } from '@forms/form-components/form-modals';
import { useSafeTranslate } from '@hooks/use-safe-translate';

interface CheckboxProps {
  fieldProperties: FieldProperties;
  register: UseFormRegister<FieldValues>;
  errors?: { [key: string]: FieldErrors };
}

const Checkbox = (props: CheckboxProps): JSX.Element => {
  const { fieldProperties, register, errors } = props;
  const {
    fieldTitle,
    fieldName,
    required,
    list,
    errorMessage,
    htmlLabel,
  }: FieldProperties = fieldProperties;
  let counter = 0;

  const placeHolder = useSafeTranslate('Other', true);

  return (
    <>
      {fieldTitle && (
        <h3 className={required ? 'required' : ''}>
          <Translate>{fieldTitle}</Translate>
        </h3>
      )}

      <fieldset
        className={`checkbox-field-group small-rounded-corners ${errors?.[fieldName] ? 'error' : ''} `}>
        {list &&
          list.length > 0 &&
          list.map((checkbox) => {
            const { name, label } = checkbox;
            if (name === 'Other') {
              return (
                <input
                  name={`Other`}
                  key={name}
                  type={`text`}
                  className={`other-text-input`}
                  placeholder={placeHolder}
                  {...register(`${fieldName}.${counter++}.other`, {
                    required,
                  })}
                />
              );
            }
            return (
              <div className={`checkbox-field`} key={name}>
                <input
                  type="checkbox"
                  placeholder={name}
                  id={name}
                  {...register(`${fieldName}.${counter++}.${name}`, {
                    required,
                  })}
                />
                {htmlLabel && label ? (
                  <label
                    htmlFor={name}
                    dangerouslySetInnerHTML={{ __html: label }}
                  />
                ) : (
                  <label htmlFor={name}>
                    <Translate>{name}</Translate>
                  </label>
                )}
              </div>
            );
          })}
      </fieldset>

      {errors?.[fieldName] && (
        <p className="error-message">
          <Translate>{errorMessage}</Translate>
        </p>
      )}
    </>
  );
};

export default Checkbox;
